import { MeiliSearch } from 'meilisearch'
import { MEILISEARCH_API_KEY, MEILISEARCH_HOST } from '@/lib/config'

const client = new MeiliSearch({
  host: MEILISEARCH_HOST,
  apiKey: MEILISEARCH_API_KEY,
})

export default client
